var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99932 28.6666C7.06772 28.6666 6.27926 28.344 5.63395 27.6987C4.98866 27.0534 4.66602 26.2649 4.66602 25.3333V21.4872H8.66602V3.33337H27.3326V25.3333C27.3326 26.2649 27.01 27.0534 26.3647 27.6987C25.7194 28.344 24.9309 28.6666 23.9993 28.6666H7.99932ZM23.9993 26.6667C24.3771 26.6667 24.6938 26.5389 24.9493 26.2833C25.2049 26.0278 25.3327 25.7111 25.3327 25.3333V5.33334H10.666V21.4872H22.666V25.3333C22.666 25.7111 22.7938 26.0278 23.0493 26.2833C23.3049 26.5389 23.6215 26.6667 23.9993 26.6667ZM12.2557 11.5897V9.58978H23.7429V11.5897H12.2557ZM12.2557 15.4359V13.4359H23.7429V15.4359H12.2557ZM7.99932 26.6667H20.666V23.4871H6.66598V25.3333C6.66598 25.7111 6.79376 26.0278 7.04932 26.2833C7.30487 26.5389 7.62154 26.6667 7.99932 26.6667ZM7.99932 26.6667H6.66598H20.666H7.99932Z",
    fill: "#434545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiIcon);
export default __webpack_public_path__ + "static/media/pi-icon.4d030c8dacae32b0b1bc3b8b13e96c1b.svg";
export { ForwardRef as ReactComponent };